/**
 * CommentListNone
 */

import Config from '../../Config';
import Util from '../../Util';
import Template from '../Template';

class CommentListNone {

	private $parent: any;

	private pId: string;

	private id: string;

	constructor( $parent: any ) {
		this.$parent = $parent;
		this.pId = this.$parent.attr( 'id' );
		this.id = 'comment-article-none';
	}

	public remove() {
		jQuery( `#${ this.pId } .${ this.id }` ).remove();
	}

	public setUI() {
		return this.template();
	}

	private template() {
		return `<div class="${ this.id }"><p>${ Config.L10N.comment_none_article }</p></div>`;
	}
}

export default CommentListNone;
